<template>
    <div class="quote-detail-page">
        <!-- Header -->
        <header class="page-header">
            <div class="header-content">
                <button @click="goBack" class="btn-back">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M19 12H5m7-7l-7 7 7 7"></path>
                    </svg>
                    Voltar para Admin
                </button>

                <div class="header-title">
                    <h1>Detalhes da Cotação</h1>
                    <p v-if="quoteDetail" class="quote-id">#{{ quoteDetail.ide }}</p>
                </div>

                <div class="header-actions">
                    <button v-if="quoteDetail" @click="goBack" class="btn-close">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    </button>
                </div>
            </div>
        </header>

        <!-- Loading State -->
        <div v-if="loading" class="loading-container">
            <div class="loading-spinner">
                <div class="spinner"></div>
                <p>Carregando detalhes da cotação...</p>
            </div>
        </div>

        <!-- Error State -->
        <div v-else-if="error" class="error-container">
            <div class="error-content">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="15" y1="9" x2="9" y2="15"></line>
                    <line x1="9" y1="9" x2="15" y2="15"></line>
                </svg>
                <h3>Erro ao carregar cotação</h3>
                <p>{{ error }}</p>
                <button @click="loadQuoteDetail" class="btn-retry">Tentar Novamente</button>
            </div>
        </div>

        <!-- Quote Detail Form -->
        <div v-else-if="quoteDetail" class="quote-detail-content">
            <QuoteDetailForm :quoteDetail="quoteDetail" @situation-updated="handleSituationUpdate" @reload-quote-detail="reloadQuoteDetail" />
        </div>

        <!-- Not Found State -->
        <div v-else class="not-found-container">
            <div class="not-found-content">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <circle cx="11" cy="11" r="8"></circle>
                    <path d="M21 21l-4.35-4.35"></path>
                </svg>
                <h3>Cotação não encontrada</h3>
                <p>A cotação solicitada não foi encontrada ou não existe.</p>
                <button @click="goBack" class="btn-back-to-admin">Voltar para Admin</button>
            </div>
        </div>
    </div>
</template>

<script>
import QuoteDetailForm from '../components/QuoteDetailForm.vue'
import api from '../services/api'

export default {
    name: 'QuoteDetailPage',
    components: {
        QuoteDetailForm
    },
    data() {
        return {
            quoteDetail: null,
            loading: true,
            error: null
        }
    },
    async mounted() {
        await this.loadQuoteDetail()
    },
    methods: {
        async loadQuoteDetail() {
            try {
                this.loading = true
                this.error = null

                const quoteId = this.$route.params.id
                if (!quoteId) {
                    this.error = 'ID da cotação não fornecido'
                    return
                }

                const response = await api.get(`/vehicle-insurance/quotes/${quoteId}`)
                this.quoteDetail = response.data
            } catch (err) {
                console.error('Erro ao carregar detalhes da cotação:', err)
                this.error = err.response?.data?.message || 'Erro ao carregar detalhes da cotação'
            } finally {
                this.loading = false
            }
        },

        goBack() {
            this.$router.push('/admin')
        },

        handleSituationUpdate(newSituation) {
            if (this.quoteDetail) {
                this.quoteDetail.situation = newSituation
            }
        },

        async reloadQuoteDetail() {
            await this.loadQuoteDetail()
        }
    }
}
</script>

<style scoped>
.quote-detail-page {
    min-height: 100vh;
    background: #f8fafc;
}

.page-header {
    background: white;
    border-bottom: 1px solid #e5e7eb;
    padding: 1rem 0;
    position: sticky;
    top: 0;
    z-index: 100;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.header-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
}

.btn-back {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    background: #f3f4f6;
    color: #374151;
    border: none;
    border-radius: 8px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    text-decoration: none;
}

.btn-back:hover {
    background: #e5e7eb;
    transform: translateY(-1px);
}

.header-title {
    flex: 1;
    text-align: center;
}

.header-title h1 {
    font-size: 1.5rem;
    font-weight: 700;
    color: #1f2937;
    margin: 0;
}

.quote-id {
    font-size: 0.875rem;
    color: #6b7280;
    margin: 0.25rem 0 0 0;
    font-family: 'Courier New', monospace;
}

.header-actions {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.btn-close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: #f3f4f6;
    color: #6b7280;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-close:hover {
    background: #e5e7eb;
    color: #374151;
}

.quote-detail-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem 1rem;
}

.loading-container,
.error-container,
.not-found-container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 60vh;
    padding: 2rem;
}

.loading-spinner,
.error-content,
.not-found-content {
    text-align: center;
    max-width: 400px;
}

.spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #e5e7eb;
    border-top: 4px solid #3b82f6;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 0 auto 1rem;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.loading-spinner p,
.error-content p,
.not-found-content p {
    color: #6b7280;
    margin: 0.5rem 0 1.5rem 0;
}

.error-content svg,
.not-found-content svg {
    color: #ef4444;
    margin-bottom: 1rem;
}

.error-content h3,
.not-found-content h3 {
    color: #1f2937;
    margin: 0 0 0.5rem 0;
    font-size: 1.25rem;
    font-weight: 600;
}

.btn-retry,
.btn-back-to-admin {
    padding: 0.75rem 1.5rem;
    background: #3b82f6;
    color: white;
    border: none;
    border-radius: 8px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-retry:hover,
.btn-back-to-admin:hover {
    background: #2563eb;
    transform: translateY(-1px);
}

@media (max-width: 768px) {
    .header-content {
        flex-direction: column;
        gap: 1rem;
        text-align: center;
    }

    .header-title {
        order: -1;
    }

    .btn-back {
        align-self: flex-start;
    }

    .header-actions {
        align-self: flex-end;
    }

    .quote-detail-content {
        padding: 1rem;
    }
}

</style>
